/**
 * Social sharing functionality
 * @module social
 */

/**
 * Initializes Pinterest sharing functionality
 */
export function initializePinterestSharing() {
  const hiddenImage = document.querySelector('img[data-pin-media]');
  if (!hiddenImage) return;

  const shareData = {
    imageUrl: hiddenImage.getAttribute('data-pin-media'),
    description: hiddenImage.getAttribute('data-pin-description'),
    pageUrl: hiddenImage.getAttribute('data-pin-url'),
  };

  updatePinterestButton(shareData);
}

function updatePinterestButton({ imageUrl, description, pageUrl }) {
  const shareButton = document.querySelector('a.share-pinterest');
  if (!shareButton) return;

  const shareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(pageUrl)}&media=${imageUrl}&description=${encodeURIComponent(description)}`;
  shareButton.setAttribute('href', shareUrl);
}
